import React, { useState } from 'react';
import { Section, FadeIn } from './Shared';
import { ShieldCheckIcon, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const GuaranteeAndFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el GAP 360 después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de acceso a todos los archivos. En menos de 5 minutos tenés todo disponible para descargar.'
  }, {
    q: '¿Sirve para instructoras con poca experiencia o solo para las avanzadas?',
    a: 'GAP 360 está diseñado para todos los niveles. Desde la instructora que quiere incorporar GAP por primera vez hasta la que ya lo enseña y quiere sistematizar y profesionalizar su método.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Los PDFs son de uso personal. No son editables para proteger el contenido, pero las plantillas imprimibles están diseñadas para completar a mano o en digital.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en ambas ofertas sin costo adicional.'
  }, {
    q: '¿Sirve si doy clases individuales o solo para grupos?',
    a: 'Sirve para ambas modalidades. Los ejercicios, fichas y protocolos están adaptados tanto para clases individuales como grupales.'
  }, {
    q: '¿Sirve si tengo alumnas de distintos niveles al mismo tiempo?',
    a: 'Exactamente para eso está diseñado. El sistema de variaciones en 3 niveles te permite dar la misma clase a grupos heterogéneos sin perder a ninguna alumna.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales de GAP?',
    a: 'GAP 360 es el único sistema que combina base técnica con entrenamiento GAP, con planificación de 90 días, recursos para poblaciones especiales y un tomo completo de negocio. No es una colección de ejercicios: es un sistema completo.'
  }, {
    q: '¿Por qué elegir el GAP 360 Rose Gold Edition y no el estándar?',
    a: 'Si además de dar las mejores clases GAP querés construir un negocio digital escalable y trabajar con periodización avanzada, la Rose Gold Edition es tu opción. Por una diferencia de $8.000 accedés a un sistema completo de negocio digital y a 6 meses de programación periodizada.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% sin preguntas.'
  }];
  return <>
      <Section bg="charcoal" data-id="element-79">
        <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-80">
          <ShieldCheckIcon size={48} className="text-gold mx-auto mb-4 md:mb-6 md:w-20 md:h-20" data-id="element-81" />
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-4 md:mb-6" data-id="element-82">
            GARANTÍA GAP 360 — 7 DÍAS
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-4 md:mb-6" data-id="element-83">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-gold font-semibold text-sm md:text-base" data-id="element-84">
            La confianza que tenemos en GAP 360 nos permite hacer esa promesa
            sin dudar. La tasa de devoluciones es menor al 1%.
          </p>
        </FadeIn>
      </Section>

      <Section bg="white" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          <h2 className="text-2xl md:text-4xl font-extrabold text-charcoal text-center mb-8 md:mb-12" data-id="element-87">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-2.5 md:space-y-4" data-id="element-88">
            {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg md:rounded-xl overflow-hidden" data-id="element-89">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3 md:p-6 bg-white hover:bg-gray-50 text-left transition-colors" data-id="element-90">
                  <span className="font-bold text-charcoal pr-4 text-sm md:text-base" data-id="element-91">
                    {faq.q}
                  </span>
                  <ChevronDownIcon size={18} className={`text-coral transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-92" />
                </button>
                <AnimatePresence data-id="element-93">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-94">
                      <div className="p-3 md:p-6 pt-0 text-gray-600 bg-white text-sm md:text-base" data-id="element-95">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
};